import { AxiosError } from "axios";
import { NavigateFunction } from "react-router-dom";
import { MissingResource } from "../pages/ResourceNotFound";

/**
 * True when a request failed because the resource doesn't exist (or isn't
 * visible to this user).
 *
 * This deliberately keys off the status code rather than the response body.
 * The call sites used to test for the literal string "Not found", but the API
 * answers a missing object with Django's `get_object_or_404` message —
 * `{"detail": "No Customer matches the given query."}` — so that test never
 * matched and the 404 fell through to the generic handler, leaving the page
 * body unrendered (blank screen).
 */
export const isResourceNotFoundError = (reason: AxiosError): boolean => {
  const status =
    reason?.response?.status ??
    (reason?.request as { status?: number } | undefined)?.status;
  return status === 404;
};

/** Send the user to the contextual "Site/Camera not found" page. */
export const navigateToResourceNotFound = (
  navigate: NavigateFunction,
  resource: MissingResource,
  id?: string | number
): void => {
  navigate("/not-found", { replace: true, state: { resource, id } });
};
